import {
  columnResizingFeature,
  columnSizingFeature,
  tableFeatures,
} from "@tanstack/react-table";

/**
 * The feature set every resizable grid in the workspace registers. Tables
 * extend it (`tableFeatures({ ...gridTableFeatures, tableMeta })`) so the
 * shared grid can type its table and columns against one contract.
 */
export const gridTableFeatures = tableFeatures({
  columnSizingFeature,
  columnResizingFeature,
});
export type GridTableFeatures = typeof gridTableFeatures;
